import { Fragment, useState, useEffect } from "react"

import {
  useBreakpointValue,
  Button,
  FormControl,
  FormLabel,
  Flex,
  FormHelperText,
  Input,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Select,
  Stack,
} from "@chakra-ui/react"

const DeliveryTypeButton = ({ label, isSelected, ...props }) => {
  const firstButtonStyle = useBreakpointValue({
    base: { borderTopLeftRadius: "md", borderTopRightRadius: "md" },
    sm: { borderTopLeftRadius: "md", borderBottomLeftRadius: "md" },
  })
  const lastButtonStyle = useBreakpointValue({
    base: { borderBottomLeftRadius: "md", borderBottomRightRadius: "md" },
    sm: { borderTopRightRadius: "md", borderBottomRightRadius: "md" },
  })

  return (
    <Button
      variant="solid"
      isFullWidth
      colorScheme={isSelected ? "teal" : "gray"}
      zIndex={isSelected ? "100" : null}
      borderRadius={0}
      _first={firstButtonStyle}
      _last={lastButtonStyle}
      fontSize={{ base: "md", sm: "sm", md: "md" }}
      {...props}
    >
      {label}
    </Button>
  )
}

const OrderForm = ({ isLoading, onSubmit, modalController, locations }) => {
  const [name, setName] = useState("")
  const [surname, setSurname] = useState("")
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState("")
  const [city, setCity] = useState()
  const [address, setAddress] = useState("")
  const [isDelivery, setIsDelivery] = useState(true)

  const onSave = () => {
    if (
      name !== "" &&
      surname !== "" &&
      phone !== "" &&
      email !== "" &&
      (address !== "" || !isDelivery)
    ) {
      onSubmit({
        name,
        surname,
        phone,
        email,
        city,
        cityName: locations.find((loc) => loc.id === city).name,
        address,
      })
      modalController.onClose()
    }
  }

  useEffect(() => setCity(locations?.[0]?.id), [locations])

  return (
    <Fragment>
      <Modal
        isCentered
        isOpen={modalController.isOpen}
        onClose={modalController.onClose}
        size="full"
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Conferma Ordine</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Stack spacing={4}>
              <FormControl isRequired>
                <FormLabel>Nome</FormLabel>
                <Input
                  placeholder="Nome"
                  size="md"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel>Cognome</FormLabel>
                <Input
                  placeholder="Cognome"
                  size="md"
                  value={surname}
                  onChange={(event) => setSurname(event.target.value)}
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel>Telefono</FormLabel>
                <Input
                  placeholder="Telefono"
                  size="md"
                  value={phone}
                  onChange={(event) => setPhone(event.target.value)}
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel>Email</FormLabel>
                <Input
                  type="email"
                  placeholder="Email"
                  size="md"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
              </FormControl>

              <FormControl>
                <Flex
                  spacing={{ base: 4, md: 4 }}
                  direction={{ base: "column", sm: "row" }}
                >
                  <DeliveryTypeButton
                    label="Consegna Domicilio"
                    isSelected={isDelivery}
                    onClick={() => {
                      setIsDelivery(true)
                      setCity(locations?.[0]?.id)
                    }}
                  />
                  <DeliveryTypeButton
                    label="Punto di Ritiro"
                    isSelected={!isDelivery}
                    onClick={() => {
                      setIsDelivery(false)
                      setCity(locations.filter((l) => l.isRitiro)?.[0]?.id)
                    }}
                  />
                </Flex>
              </FormControl>

              {isDelivery ? (
                <Fragment>
                  <FormControl isRequired>
                    <FormLabel>Comune</FormLabel>
                    <Select onChange={(event) => setCity(event.target.value)}>
                      {locations.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                    </Select>
                    <FormHelperText>
                      <strong>Costo del servizio: 3,50 €</strong>
                      <br />
                      Non trovi il tuo comune? Chiamaci al{" "}
                      <Link color="teal.500" href="tel:+393466456419">
                        3466456419
                      </Link>{" "}
                      per sapere se possiamo trovare una soluzione
                    </FormHelperText>
                  </FormControl>
                  <FormControl isRequired>
                    <FormLabel>Indirizzo</FormLabel>
                    <Input
                      placeholder="Indirizzo"
                      size="md"
                      value={address}
                      onChange={(event) => setAddress(event.target.value)}
                    />
                  </FormControl>
                </Fragment>
              ) : (
                <Fragment>
                  <FormControl isRequired>
                    <FormLabel>Punto di Ritiro</FormLabel>
                    <Select onChange={(event) => setCity(event.target.value)}>
                      {locations
                        .filter((l) => l.isRitiro)
                        .map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                    </Select>
                  </FormControl>
                </Fragment>
              )}
            </Stack>
            <Flex my={6}>
              <Button
                isLoading={isLoading}
                onClick={onSave}
                colorScheme="teal"
                isFullWidth
                size="lg"
              >
                Ordina
              </Button>
            </Flex>
            <Flex my={6} visibility="hidden">
              <Button
                isLoading={isLoading}
                onClick={onSave}
                colorScheme="teal"
                isFullWidth
                size="lg"
              >
                Ordina
              </Button>
            </Flex>
          </ModalBody>

          {/*<ModalFooter>
            <Button
              isLoading={isLoading}
              onClick={onSave}
              colorScheme="teal"
              isFullWidth
            >
              Ordina
            </Button>
          </ModalFooter>*/}
        </ModalContent>
      </Modal>
    </Fragment>
  )
}

export default OrderForm
